import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-user-guide',
  templateUrl: './user-guide.component.html',
  styleUrls: ['./user-guide.component.scss']
})
export class UserGuideComponent implements OnInit {
  @Input() transitionParams: any;
  @Input() contentPath: any;

  eulaContent: SafeHtml = '';
  basePath = '/assets/userguide'
  path: string;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    
    let path = this.basePath;

    let page = this.transitionParams.page;
    let section = this.transitionParams.section;
    let subsection = this.transitionParams.subsection;

// normalise the path based
    if (page.indexOf('.html') === -1 && !subsection) {
      subsection = page;
      page = 'index.html';
    }
    // else {

    //   section = page;
    //   page = 'index.html';
    // }

    if (section) path = path + '/' + section;
    if (subsection) path = path + '/' + subsection;

    path = path + '/' + page
    this.path = path; 
    
    fetch(path)
      .then(res => res.text())
      .then(data => {
        this.eulaContent = this.sanitizer.bypassSecurityTrustHtml(data);
      });
  }

}




